import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ThemeState {
    dark: boolean;
    toggle: () => void;
    setDark: (dark: boolean) => void;
}

export const useThemeStore = create<ThemeState>()(
    persist(
        (set) => ({
            dark: document.documentElement.classList.contains('dark'),
            toggle: () =>
                set(state => {
                    const next = !state.dark;
                    document.documentElement.classList.toggle('dark', next);
                    return { dark: next };
                }),
            setDark: (dark: boolean) => {
                document.documentElement.classList.toggle('dark', dark);
                set({ dark });
            },
        }),
        {
            name: 'theme',
            onRehydrateStorage: () => (state) => {
                if (state) {
                    document.documentElement.classList.toggle('dark', state.dark);
                }
            },
        }
    )
);
